import styled from 'styled-components';

import { BaseInfo } from '../../svg/Info';

import { colors, spacing } from '../../constants';

export const InfoIcon = styled(BaseInfo)`
    width: 16px;
    height: 16px;
    margin-left: ${spacing.md};
    fill: ${colors.transparentBlack};
`;
